<div [ngClass]="{ disabled: disabled }">
    <form [formGroup]="phoneNumberFormGroup">
        <div>
            <strong
                >{{ label | translate }}
                @if (required) {
                    <span class="required">*</span>
                }
            </strong>
        </div>

        <div class="mt-10px flex">
            <mat-form-field appearance="outline" class="evida-phone-number-country-code country-code mr10">
                <mat-select formControlName="countryCode" (selectionChange)="countryCodeChanged($event.value)">
                    @for (countryCode of countryCodes; track countryCode) {
                        <mat-option [value]="countryCode.value">
                            {{ countryCode.viewValue }}
                        </mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="evida-phone-number-field w-full phoneNumber">
                <input
                    type="text"
                    matInput
                    formControlName="phoneNumber"
                    [placeholder]="phoneNumberPlaceholder | translate"
                    [mask]="maskForCountryCode"
                    (change)="phoneNumberChanged($event.srcElement.value)"
                />
                @if (!phoneNumberFormGroup.controls.phoneNumber.valid) {
                    <mat-error class="body-small-header">{{ invalidPhoneNumberText | translate }}</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</div>
